<template>
  <!--成品公布价显示-->
  <div>{{price ? price : ''}}</div>
</template>

<script>
import NP from 'number-precision'
export default {
  data () {
    return {
      price: 0,
      incidental: 0,
      profit: 0,
      adjustment: 0,
      total: 0
    }
  },
  syncProps: ['value'],
  props: {
    data: Object,
    record: Object
  },
  mounted () {
    this.getData()
  },
  watch: {
    data () {
      this.getData()
    }
  },
  methods: {
    async getData () {
      await this.init(this.data)
    },
    async init (data) {
      this.price = 0
      this.adjustment = 0
      this.incidental = 0
      this.profit = 0
      this.total = 0
      if (data.adjustment) { this.adjustment = data.adjustment }
      // 获取附加费
      let sur = await this.$tkParse.getData('/classes/surcharge', {
        params: {
          where: {
            type: 'finish',
            proportion: data.proportion.objectId
          }
        }
      }).catch(e => { })
      if (sur.results.length) {
        this.incidental = sur.results[0].incidental
        this.profit = sur.results[0].profit
      }
      if (!data.formula) {
        let totalPrice = 0
        totalPrice = NP.plus(this.incidental, this.profit, this.total, this.adjustment)
        this.price = NP.round(totalPrice, 2)
        return
      }
      let w = 0
      data.formula.forEach((f) => {
        if (f.weight) { w = NP.plus(w, f.weight) }
      })
      let res = []
      let par = []
      // 获取原材料
      if (data.rawMaterialId && data.rawMaterialId.length) {
        let r = await this.$tkParse.getData('/classes/rawMaterial', {
          params: {
            where: {
              objectId: { $in: data.rawMaterialId }
            }
          }
        }).catch(e => { })
        res = r.results
      }
      // 获取半成品
      if (data.partsId && data.partsId.length) {
        let p = await this.$tkParse.getData('/classes/parts', {
          params: {
            where: {
              objectId: { $in: data.partsId }
            }
          }
        }).catch(e => { })
        par = p.results
      }
      // 计算材料费
      if (res.length || par.length) {
        data.formula.forEach((e) => {
          let rt = NP.divide(e.weight, w, 0.01)
          e.ratio = NP.round(rt, 2)
          e.tonWeight = NP.times(e.ratio, 10)
          if (e.rawMaterial) {
            let s = res.filter((f) => { return e.rawMaterial === f.objectId })
            e.price = NP.times(s[0].price, s[0].rate, e.tonWeight, 0.001, 0.01)
            this.total = NP.plus(this.total, e.price)
          }
          if (e.parts) {
            let s = par.filter((g) => { return e.parts === g.objectId })
            e.price = NP.times(s[0].price, e.tonWeight, 0.001)
            this.total = NP.plus(this.total, e.price)
          }
        }, this)
      }
      let totalPrice = 0
      totalPrice = NP.plus(this.incidental, this.profit, this.total, this.adjustment)
      this.price = NP.round(totalPrice, 2)
      this.total = 0
    }
  }
}
</script>

<style scoped>

</style>
